module.exports = __webpack_public_path__ + "static/media/Website_Video.2970480e.mp4";